import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { Observable } from 'rxjs';
import { IPerson } from '../../models/person.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  baseHttpService = inject(BaseHttpService);

  constructor() { }

  public searchPerson(firstName?: string, surName?: string, id?: number): Observable<IPerson[]> {
    if (!firstName && !surName && !id) return new Observable<IPerson[]>();

    let params = new HttpParams();
    
    if (firstName) params = params.set('firstName', firstName);
    if (surName) params = params.set('surName', surName);
    if (id) params = params.set('id', id.toString());

    return this.baseHttpService.get<IPerson[]>('/person', { params });
  }

  public GetByEmail(email: string): Observable<IPerson> {
    let params = new HttpParams();
    
    if (email) params = params.set('email', email);
    return this.baseHttpService.get<IPerson>('/person/email/', { params });
  }
}
